var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"a-button",attrs:{"href":_vm.authLink}},[_c('img',{staticClass:"button-logo",attrs:{"src":require("@/assets/apple_icon_light.svg"),"alt":"apple"}}),_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.$t(_vm.text)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }